export default __webpack_public_path__ + "static/media/d.f5309da93764f3d744337a4fb600e149.mp3";